import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Button, List, ListItemButton, Typography, Checkbox, FormControl, Select, ListItemText, ListItem, Snackbar } from '@mui/material';

import { map, findIndex } from "lodash";
import CircleIcon from "@mui/icons-material/Circle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import { getUsersByRoleId, updateUsersAction, fetchUserByUid, formateName } from "./Services";
import { getClassNames } from "../../Js/Common";


const AssignTrainersClass = (props) => {

    // Hooks
    const styles = useStyles();

    //const { uid } = useParams();
    const { paramsdata } = useSelector((state) => state.common);

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const [trainerList, setTrainerList] = useState([]);
    const [selectedTrainers, setSelectedTrainers] = useState([]);
    const [allClasses, setAllClasses] = useState([]);
    const [selectedClassIds, setSelectedClassIds] = useState([]);

    const [stateSnackbar, setStateSnackbar] = useState({ open: false, vertical: 'bottom', horizontal: 'center' });
    const { vertical, horizontal, open } = stateSnackbar;
    const [snackbarMessage, setSnackbarMessage] = useState('');

    // React logic hooks
    useEffect(() => {
      const innerfunction = async() => {
        // console.log("paramsdata.rolesData.uid",paramsdata.rolesData.uid);
        let classData = await getClassNames(userInfo.site_uuid);
        // console.log("classData",classData);
        setAllClasses(classData);
        await fetchUsersByRole();
      }
      innerfunction();
    }, [userInfo, paramsdata]);

    const fetchUsersByRole = async () => {
      let params = {
        query: {
          $select: ['uid','name','class_assigned'],
          $limit: -1,
          role_uid: paramsdata.rolesData.uid,
          site_uuid: userInfo.site_uuid,
          status: true,
        },
      };
      let resUsersData = await getUsersByRoleId(params);
      console.log("resUsersData ===>",resUsersData);
      setTrainerList(resUsersData.data);
    };

     // Add & Remove tasks from selection
    const addInTrainers = (val) => {
      console.log("val",val);
      let newArr = [];
      newArr = selectedTrainers;
      let obj = {};
      obj.id = val.uid;
      obj.name = formateName(val.name);
      if(newArr.length === 0){
        newArr.push(obj);
      }
      else{
        let pos = findIndex(newArr, { id: val.uid });
        if(pos === -1)
            newArr.push(obj);
        else
            newArr.splice(pos,1);
      }
      setSelectedTrainers([...newArr]);
    };

    const setClassSelection = (id,nm) => {
      console.log("nm=======",nm);
      let newArr = [...selectedClassIds];
      let position = newArr.indexOf(id);
      if(position === -1){
        newArr.push(id);
      }
      else{
        newArr.splice(position,1);
      }
      setSelectedClassIds(newArr);
      if (newArr.length !== 0){
        selectedClass(newArr);
      }
      else{
        setSelectedTrainers([]);
      }
    };

    const selectedClass = (idsArr) => {
      console.log("selectedClassIds",idsArr);
      let cnt = idsArr.length;
      let selCls = idsArr[cnt - 1];
      console.log("selCls====",selCls);
      for (let i = 0; i < trainerList.length; i++) {
        let tClass = trainerList[i].class_assigned;
        console.log("tClass",trainerList[i].uid, tClass);
        if (tClass != null) {
          for (let j = 0; j < tClass.length; j++) {
            if (selCls === tClass[j]) {
              const pos = selectedTrainers.findIndex((val)=>{ return val.id === trainerList[i].uid})
              if(pos  !== -1){
                break;
              }
              let obj = {};
              obj.id = trainerList[i].uid;              
              obj.name = formateName(trainerList[i].name);
              let newArr = selectedTrainers;
              newArr.push(obj);
              setSelectedTrainers([...newArr]);
              break;
            }
          }
        }
      }
    };

    const assignTrainer = async() => {
      if(selectedClassIds.length === 0){
        setSelectedTrainers([]);
        setSelectedClassIds([]);
        setSnackbarMessage('Please select class');
        setStateSnackbar({ ...stateSnackbar, open: true });
        return;
      }
      await removeTrainer();
      if (selectedTrainers.length === 0)
      {
        setSnackbarMessage('Assigned/Removed class successfully!');
        setStateSnackbar({ ...stateSnackbar, open: true });
        setSelectedTrainers([]);
        setSelectedClassIds([]);
        await fetchUsersByRole();
        return;
      }

      for (let i = 0; i < selectedTrainers.length; i++) {
        let params = {
          query: {
            $select: ['id', 'uid', 'class_assigned'],
            uid: [selectedTrainers[i].id],
            $limit: 1,
            'site_uuid':userInfo.site_uuid
          }
        };
        let resData2 = await fetchUserByUid(params);
        console.log("resData2==",resData2);

        let updatedId = resData2.data.data[0].id;
        let classAssign = resData2.data.data[0].class_assigned;
        if (classAssign == null) {
          classAssign = [];
          classAssign = classAssign.concat(selectedClassIds);
        } else {
          for (let j = 0; j < selectedClassIds.length; j++) {
            if (classAssign.indexOf(selectedClassIds[j]) > -1) {
              // console.log("Exist");
            } else {
              //Not in the array
              classAssign.push(selectedClassIds[j]);
            }
          }
        }
        let data = {};
        data.class_assigned = classAssign;
        data.is_synced = false;
        let params1 = {};
        let response = await updateUsersAction(updatedId, data, params1);
        console.log("response===",response);
      }
      setSnackbarMessage('Assigned/Removed class successfully!');
      setStateSnackbar({ ...stateSnackbar, open: true });
      setSelectedTrainers([]);
      setSelectedClassIds([]);
      await fetchUsersByRole();
    };

    const removeTrainer = async() => {
      for (let j = 0; j < selectedClassIds.length; j++) {
        let trData = trainerList;
        for (let t = 0; t < trData.length; t++) {
          let tClass = trData[t].class_assigned;
          let flg = false;
          if (tClass != null) {
            for (let k = 0; k < tClass.length; k++) {
              if (tClass[k] === selectedClassIds[j]) {
                tClass.splice(k, 1);
                flg = true;
              }
            }
            if (flg === true) {
              if (tClass.length === 0){
                tClass = null;
              }
              console.log("trData[t]",trData[t]);

              let params = {
                query: {
                  $select: ['id', 'uid'],
                  uid: [trData[t].uid],
                  $limit: 1,
                  'site_uuid':userInfo.site_uuid
                }
              };
              let resData2 = await fetchUserByUid(params);
              console.log("resData2====",resData2);

              let updatedId = resData2.data.data[0].id;
              let data = {};
              data.class_assigned = tClass;
              data.is_synced = false;
              let params1 = {};
              let response = await updateUsersAction(updatedId, data, params1);
              console.log("response===",response);
            }
          }
        }
      }
    };

    const handleClose = () => {
      setStateSnackbar({ ...stateSnackbar, open: false });
    };


    return (
        <Grid container sx={{
            flexDirection: 'row', justifyContent: 'flex-start',
        }}>
            <Grid item xs={12} sx={{}}>
                <Box sx={{ py: 2, mx: 4, mt: 1, }}>
                    <Grid container sx={{ flexDirection: 'row', flexFlow: 'wrap', justifyContent: 'center', px: 2, gap: 1, }}>
                        <Grid xs={12}>
                            <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', px: 4 }}>
                                <Grid item>
                                    <Typography sx={{ color: '#5f5600ff', fontSize: '1rem', fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}>
                                        Assign Trainers to Class
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Button onClick={assignTrainer} sx={{ fontSize: '0.8rem', fontWeight: '600', color: '#5f5600ff', backgroundColor: '#F5F5F5', borderRadius: 10, '&:hover': { backgroundColor: '#5f5600ff', color: '#FFFFFF' },'@media (min-width: 1636px)': {fontSize: '1.2rem', px:2} }}> Assign </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={7} className={styles.scrollBar} sx={{ height: '75vh', overflow: 'auto', }}>
                            {allClasses && allClasses.length > 0 ? (
                            <Grid
                              container
                              spacing={1}
                              marginTop={2}
                              className={styles.scrollBar}
                              sx={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}
                            >
                              {allClasses.map((objUser, index) => {
                                return (<>
                                  <Grid item xs={5} key={`${index}_user`}>
                                    <List dense sx={{ p: 0, m: 0, pb: 1 }}>
                                      <ListItem sx={{ p: 0 }} disablePadding>
                                        <ListItemButton
                                          sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                                          onClick={() => { setClassSelection(objUser.id, "list")}}
                                        >
                                          <Checkbox
                                            icon={<RadioButtonUncheckedIcon />}
                                            checkedIcon={<CircleIcon />}
                                            value={objUser.uid}
                                            checked={selectedClassIds.indexOf(objUser.id) !== -1}  
                                          />
                                          <ListItemText sx={{ m: 0, px: 0, py: 0.3 }}
                                            primary={
                                              <Typography
                                                sx={{fontSize: '0.9rem',fontWeight: '500' , color: "#5f5600ff",'@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
                                              >
                                                {objUser.value}
                                              </Typography>
                                            }
                                          />
                                        </ListItemButton>
                                      </ListItem>
                                    </List>
                                  </Grid>
                                   <Grid item xs={7} sx={{display: 'flex'}}>
                                    { trainerList &&
                                        trainerList.map((val, index) => {
                                        return (
                                          val.class_assigned
                                          && val.class_assigned
                                          != null && val.class_assigned
                                          .indexOf(objUser.id) > -1 &&
                                          <Typography sx={{color: '#5f5600ff', fontWeight: '500', fontSize: '0.9rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}}}>
                                             {formateName(val.name)} 
                                            <span sx={{color: '#A9A9A9' }}> | </span>
                                          </Typography>
                                        );
                                    })}
                                  </Grid>
                                  </>
                                );
                              })}
                            </Grid>
                            ) : (
                            <Typography>Please create class hierarchy</Typography>
                            )}
                        </Grid>
                        <Grid item xs={4}>
                        <>
                        <Typography
                            color="#5f5600ff"
                            sx={{
                            ml: 3,
                            mt: 2,
                            letterSpacing: 1,
                            fontSize: "0.9rem",
                            fontWeight: '500'
                            ,'@media (min-width: 1636px)': {fontSize: '1.4rem'}
                            }}
                        >
                            Select Trainers:
                        </Typography>
                        <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
                            {selectedTrainers && (
                            <Select
                                value={selectedTrainers}
                                displayEmpty
                                placeholder="Select Trainer"
                                inputProps={{ "aria-label": "Without label" }}
                                sx={{
                                borderRadius: 5,
                                borderColor: "#FFFFFF",
                                backgroundColor: "#F5F5F5",
                                fontWeight: '500'
                                ,'@media (min-width: 1636px)': {fontSize: '1.4rem'}
                                }}
                                multiple
                                renderValue={(selected) => {
                                    console.log("selected",selected);
                                return map(selected, "name").join(", ");
                                }}
                            >
                                {trainerList &&
                                trainerList.map((val, index) => {
                                    return (
                                    <Grid container key={`${index}_Trainer`}>
                                        <Grid item xs={2}>
                                        <Checkbox
                                            checked={
                                            findIndex(selectedTrainers, {
                                                id: val.uid,
                                            }) > -1
                                            }
                                            onClick={() => addInTrainers(val)}
                                        />
                                        </Grid>
                                        <Grid item xs={10} sx={{ paddingTop: 0.8 }}>
                                        <ListItemText primary={formateName(val.name)} sx={{}}/>
                                        </Grid>
                                    </Grid>
                                    );
                                })}
                            </Select>
                            )}
                        </FormControl>
                        </>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={6000}
                open={open}
                onClose={handleClose}
                message={snackbarMessage}
                key={vertical + horizontal}
                ContentProps={{
                    classes: {
                        root: styles.root
                    }
                }}
                sx = {{top: {xs:90,sm:0}}}
            />
        </Grid>
    )
}
const useStyles = makeStyles({
    ListItemText: {
        fontSize: '1rem !important'
    },
    scrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.2em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
    scrollBarHeight: {
        "&::-webkit-scrollbar": {
            height: '0.2em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
})
export default AssignTrainersClass;